import { getExtensionValue } from "@medplum/core";
import { QuestionnaireResponse } from "@medplum/fhirtypes";

import { Extensions } from "@/fhir/enums/extensions";
import { setExtensionValue } from "@/utils/medplum";

/**
 * Bumps `questionnaire-response-named-version` (v0→v1, v1→v2, …) and marks the
 * response completed when an encounter amendment is signed and locked.
 */
export function applyEncounterQuestionnaireResponseAmendmentVersioning(
  questionnaireResponse: QuestionnaireResponse,
): QuestionnaireResponse {
  const version = getExtensionValue(
    questionnaireResponse,
    Extensions.QuestionnaireResponseNamedVersion,
  )?.toString();

  const currentVersionNumber = version?.match(/^v(\d+)$/i)?.[1];
  const nextVersionNumber = currentVersionNumber
    ? Number.parseInt(currentVersionNumber, 10) + 1
    : 1;

  let extension = questionnaireResponse.extension ?? [];
  extension = setExtensionValue(extension, Extensions.QuestionnaireResponseNamedVersion, {
    valueString: `v${nextVersionNumber}`,
  });
  extension = setExtensionValue(extension, Extensions.QuestionnaireResponseIsCompleted, {
    valueBoolean: true,
  });

  return {
    ...questionnaireResponse,
    extension,
  };
}
